'use client';

import React, { useState, useEffect } from "react";
import "./RecentLineup.scss";
import NoData from "@/components/client/NoData";
import DataRecentLineup from "@/components/client/DataRecentLineup";
import CollapsiblePanel from "@/components/client/CollapsiblePanel";
import ICON_ARROW_UP_LEAGUES from "@/public/arrow_up_white_leagues.svg";
import ICON_ARROW_DOWN_LEAGUES from "@/public/arrow_down_white_leagues.svg";
import MatchServices from "@/services/MatchServices";
import LoadingInner from "@/app/loadingInner";

const IMAGE_ARROW_DOWN_LEAGUES = ICON_ARROW_DOWN_LEAGUES.src;
const IMAGE_ARROW_UP_LEAGUES = ICON_ARROW_UP_LEAGUES.src;

export default function RecentLineup({ matchId }) {
  const [match, setMatch] = useState(null);
  const [lineupData, setLineupData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLineupData = async () => {
      try {
        if (!matchId) {
          setLoading(false);
          return;
        }

        const matchData = await MatchServices.getMatchById(matchId);
        setMatch(matchData);

        const homeId = matchData?.homeId;
        const awayId = matchData?.awayId;

        if (homeId && awayId) {
          const lineup = await MatchServices.getMatchLineups(
            matchId,
            homeId,
            awayId
          );
          setLineupData(lineup);
        }
      } catch (error) {
        console.error("Error fetching lineup data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLineupData();
  }, [matchId]);

  if (loading) {
    return (
      <CollapsiblePanel
        title="Đội hình gần đây"
        initOpen={true}
        iconUp={IMAGE_ARROW_UP_LEAGUES}
        iconDown={IMAGE_ARROW_DOWN_LEAGUES}
      >
        <LoadingInner/>
      </CollapsiblePanel>
    );
  }

  if (!match || !lineupData) {
    return <NoData />;
  }

  return (
    <CollapsiblePanel
      title="Đội hình gần đây"
      initOpen={true}
      iconUp={IMAGE_ARROW_UP_LEAGUES}
      iconDown={IMAGE_ARROW_DOWN_LEAGUES}
    >
      <DataRecentLineup lineupData={lineupData} match={match} />
    </CollapsiblePanel>
  );
}
